import { render, staticRenderFns } from "./DinnerList.vue?vue&type=template&id=0f0ba007&scoped=true&"
import script from "./DinnerList.vue?vue&type=script&lang=js&"
export * from "./DinnerList.vue?vue&type=script&lang=js&"
import style0 from "./DinnerList.vue?vue&type=style&index=0&id=0f0ba007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ba007",
  null
  
)

export default component.exports